/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddDomainToCustomerRequest,
  BulkCustomerDomainsGroupedResponse,
  BulkCustomerDomainsRequest,
  ConsentUrlResponse,
  DomainMappingIdpClaimMappingValidateRequest,
  DomainMappingListResponse,
  DomainMappingResponse,
  IdpClaimMappingValidationResponse,
} from '../models/index';
import {
    AddDomainToCustomerRequestFromJSON,
    AddDomainToCustomerRequestToJSON,
    BulkCustomerDomainsGroupedResponseFromJSON,
    BulkCustomerDomainsGroupedResponseToJSON,
    BulkCustomerDomainsRequestFromJSON,
    BulkCustomerDomainsRequestToJSON,
    ConsentUrlResponseFromJSON,
    ConsentUrlResponseToJSON,
    DomainMappingIdpClaimMappingValidateRequestFromJSON,
    DomainMappingIdpClaimMappingValidateRequestToJSON,
    DomainMappingListResponseFromJSON,
    DomainMappingListResponseToJSON,
    DomainMappingResponseFromJSON,
    DomainMappingResponseToJSON,
    IdpClaimMappingValidationResponseFromJSON,
    IdpClaimMappingValidationResponseToJSON,
} from '../models/index';

export interface AddDomainToCustomerOperationRequest {
    customerId: string;
    addDomainToCustomerRequest: AddDomainToCustomerRequest;
    sessionId?: string;
}

export interface BulkGetCustomerDomainsRequest {
    bulkCustomerDomainsRequest: BulkCustomerDomainsRequest;
    sessionId?: string;
}

export interface FixMismatchedAliasesRequest {
    customerId: string;
    sessionId?: string;
}

export interface GetAzureEnterpriseAppStatus1Request {
    customerId: string;
    sessionId?: string;
}

export interface GetConsentUrlRequest {
    customerId: string;
    domainId: string;
    sessionId?: string;
}

export interface GetCustomerDomainRequest {
    customerId: string;
    domainId: string;
    sessionId?: string;
}

export interface GetCustomerDomainsRequest {
    customerId: string;
    sessionId?: string;
}

export interface RemoveDomainFromCustomerRequest {
    customerId: string;
    domainId: string;
    sessionId?: string;
}

export interface UpdateCustomerDomainRequest {
    customerId: string;
    domainId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface ValidateDomainMappingIdpClaimMappingsRequest {
    customerId: string;
    domainId: string;
    domainMappingIdpClaimMappingValidateRequest: DomainMappingIdpClaimMappingValidateRequest;
    sessionId?: string;
}

/**
 * CustomerDomainManagementApi - interface
 * 
 * @export
 * @interface CustomerDomainManagementApiInterface
 */
export interface CustomerDomainManagementApiInterface {
    /**
     * Adds a new domain mapping to a customer (requires customers:update permission and customer access)
     * @summary Add domain to customer
     * @param {string} customerId Customer ID
     * @param {AddDomainToCustomerRequest} addDomainToCustomerRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDomainManagementApiInterface
     */
    addDomainToCustomerRaw(requestParameters: AddDomainToCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainMappingResponse>>;

    /**
     * Adds a new domain mapping to a customer (requires customers:update permission and customer access)
     * Add domain to customer
     */
    addDomainToCustomer(requestParameters: AddDomainToCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainMappingResponse>;

    /**
     * Returns domains grouped by customerId for customers accessible via the provided tenantIds.
     * @summary Bulk get customer domains
     * @param {BulkCustomerDomainsRequest} bulkCustomerDomainsRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDomainManagementApiInterface
     */
    bulkGetCustomerDomainsRaw(requestParameters: BulkGetCustomerDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkCustomerDomainsGroupedResponse>>;

    /**
     * Returns domains grouped by customerId for customers accessible via the provided tenantIds.
     * Bulk get customer domains
     */
    bulkGetCustomerDomains(requestParameters: BulkGetCustomerDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkCustomerDomainsGroupedResponse>;

    /**
     * Administrative endpoint to fix mismatched Keycloak aliases in domain mappings (requires customers:update permission and customer access)
     * @summary Fix mismatched Keycloak aliases
     * @param {string} customerId Customer ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDomainManagementApiInterface
     */
    fixMismatchedAliasesRaw(requestParameters: FixMismatchedAliasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Administrative endpoint to fix mismatched Keycloak aliases in domain mappings (requires customers:update permission and customer access)
     * Fix mismatched Keycloak aliases
     */
    fixMismatchedAliases(requestParameters: FixMismatchedAliasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Returns whether Azure Enterprise App (multi-tenant) mode is available for domain mappings.  This endpoint allows tenants to check if they can use the system-level Enterprise Application when creating domain mappings, without needing to see the actual Enterprise App configuration.  **Use Case:** When adding a domain mapping via the \"Add Domain Mapping\" dialog, tenants can call this endpoint to determine if they should show: 1. **Enterprise App option** (if available): Only requires tenant ID, uses shared enterprise application 2. **App Registration option**: Requires tenant ID, client ID, and client secret (customer\'s own app registration)  **Response Fields:** - `enabled`: Whether Enterprise App mode is available/enabled - `endpointType`: Multi-tenant endpoint type (\"organizations\" or \"common\") when enabled - `requiresClientCredentials`: Whether clientId/clientSecret are required when NOT using enterprise app  **Frontend Usage:** - Call this endpoint before showing the domain mapping SSO configuration form - If `enabled=true`, show a toggle/choice: \"Use Enterprise App\" or \"Use My Own App Registration\" - If customer chooses \"Use Enterprise App\", only show tenantId field - If customer chooses \"Use My Own App Registration\" or `enabled=false`, show tenantId, clientId, and clientSecret fields - Set `useEnterpriseApp=true` in the request when customer chooses enterprise app option 
     * @summary Get Azure Enterprise App configuration status
     * @param {string} customerId Customer ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDomainManagementApiInterface
     */
    getAzureEnterpriseAppStatus1Raw(requestParameters: GetAzureEnterpriseAppStatus1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns whether Azure Enterprise App (multi-tenant) mode is available for domain mappings.  This endpoint allows tenants to check if they can use the system-level Enterprise Application when creating domain mappings, without needing to see the actual Enterprise App configuration.  **Use Case:** When adding a domain mapping via the \"Add Domain Mapping\" dialog, tenants can call this endpoint to determine if they should show: 1. **Enterprise App option** (if available): Only requires tenant ID, uses shared enterprise application 2. **App Registration option**: Requires tenant ID, client ID, and client secret (customer\'s own app registration)  **Response Fields:** - `enabled`: Whether Enterprise App mode is available/enabled - `endpointType`: Multi-tenant endpoint type (\"organizations\" or \"common\") when enabled - `requiresClientCredentials`: Whether clientId/clientSecret are required when NOT using enterprise app  **Frontend Usage:** - Call this endpoint before showing the domain mapping SSO configuration form - If `enabled=true`, show a toggle/choice: \"Use Enterprise App\" or \"Use My Own App Registration\" - If customer chooses \"Use Enterprise App\", only show tenantId field - If customer chooses \"Use My Own App Registration\" or `enabled=false`, show tenantId, clientId, and clientSecret fields - Set `useEnterpriseApp=true` in the request when customer chooses enterprise app option 
     * Get Azure Enterprise App configuration status
     */
    getAzureEnterpriseAppStatus1(requestParameters: GetAzureEnterpriseAppStatus1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves or recalculates the Azure AD admin consent URL for a domain mapping tied to an Enterprise App.  This endpoint is useful when: - The Enterprise App was initially created with minimal information (client ID, secret) - The domain mapping was created and tied to the EA - The EA was later updated with additional required fields (scopes, redirect URI, etc.) - The consent URL needs to be recalculated with the updated EA configuration  The endpoint will: 1. Verify the domain mapping exists and is configured for Azure AD with Enterprise App 2. Resolve the Enterprise App configuration (checking tenant hierarchy if needed) 3. Generate the consent URL using current EA configuration (scopes, redirect URI, etc.) 4. Return detailed error information if the consent URL cannot be generated  **Required Conditions:** - Domain mapping must exist - Provider type must be Azure AD - Domain must not be already verified - Domain mapping must be bound to a tenant - Enterprise App must be enabled (useEnterpriseApp=true) - Enterprise App configuration must be valid and contain required fields 
     * @summary Get Azure AD admin consent URL for domain mapping
     * @param {string} customerId Customer ID
     * @param {string} domainId Domain mapping ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDomainManagementApiInterface
     */
    getConsentUrlRaw(requestParameters: GetConsentUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConsentUrlResponse>>;

    /**
     * Retrieves or recalculates the Azure AD admin consent URL for a domain mapping tied to an Enterprise App.  This endpoint is useful when: - The Enterprise App was initially created with minimal information (client ID, secret) - The domain mapping was created and tied to the EA - The EA was later updated with additional required fields (scopes, redirect URI, etc.) - The consent URL needs to be recalculated with the updated EA configuration  The endpoint will: 1. Verify the domain mapping exists and is configured for Azure AD with Enterprise App 2. Resolve the Enterprise App configuration (checking tenant hierarchy if needed) 3. Generate the consent URL using current EA configuration (scopes, redirect URI, etc.) 4. Return detailed error information if the consent URL cannot be generated  **Required Conditions:** - Domain mapping must exist - Provider type must be Azure AD - Domain must not be already verified - Domain mapping must be bound to a tenant - Enterprise App must be enabled (useEnterpriseApp=true) - Enterprise App configuration must be valid and contain required fields 
     * Get Azure AD admin consent URL for domain mapping
     */
    getConsentUrl(requestParameters: GetConsentUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConsentUrlResponse>;

    /**
     * Retrieves a specific domain mapping for a customer (requires customers:read permission and customer access)
     * @summary Get customer domain by ID
     * @param {string} customerId Customer ID
     * @param {string} domainId Domain mapping ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDomainManagementApiInterface
     */
    getCustomerDomainRaw(requestParameters: GetCustomerDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainMappingResponse>>;

    /**
     * Retrieves a specific domain mapping for a customer (requires customers:read permission and customer access)
     * Get customer domain by ID
     */
    getCustomerDomain(requestParameters: GetCustomerDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainMappingResponse>;

    /**
     * Retrieves all domains for a customer (requires customers:read permission and customer access)
     * @summary Get customer domains
     * @param {string} customerId Customer ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDomainManagementApiInterface
     */
    getCustomerDomainsRaw(requestParameters: GetCustomerDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainMappingListResponse>>;

    /**
     * Retrieves all domains for a customer (requires customers:read permission and customer access)
     * Get customer domains
     */
    getCustomerDomains(requestParameters: GetCustomerDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainMappingListResponse>;

    /**
     * Removes a domain mapping from a customer (requires customers:update permission and customer access)
     * @summary Remove domain from customer
     * @param {string} customerId Customer ID
     * @param {string} domainId Domain mapping ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDomainManagementApiInterface
     */
    removeDomainFromCustomerRaw(requestParameters: RemoveDomainFromCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Removes a domain mapping from a customer (requires customers:update permission and customer access)
     * Remove domain from customer
     */
    removeDomainFromCustomer(requestParameters: RemoveDomainFromCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates an existing domain mapping for a customer (requires customers:update permission and customer access)
     * @summary Update customer domain
     * @param {string} customerId Customer ID
     * @param {string} domainId Domain mapping ID
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDomainManagementApiInterface
     */
    updateCustomerDomainRaw(requestParameters: UpdateCustomerDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainMappingResponse>>;

    /**
     * Updates an existing domain mapping for a customer (requires customers:update permission and customer access)
     * Update customer domain
     */
    updateCustomerDomain(requestParameters: UpdateCustomerDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainMappingResponse>;

    /**
     * Validates IdP claim mapping rules scoped to this SSO integration using format heuristics and, when available, provider-specific external lookups. 
     * @summary Validate IdP claim mappings for a domain mapping
     * @param {string} customerId Customer ID
     * @param {string} domainId Domain mapping ID
     * @param {DomainMappingIdpClaimMappingValidateRequest} domainMappingIdpClaimMappingValidateRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerDomainManagementApiInterface
     */
    validateDomainMappingIdpClaimMappingsRaw(requestParameters: ValidateDomainMappingIdpClaimMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdpClaimMappingValidationResponse>>;

    /**
     * Validates IdP claim mapping rules scoped to this SSO integration using format heuristics and, when available, provider-specific external lookups. 
     * Validate IdP claim mappings for a domain mapping
     */
    validateDomainMappingIdpClaimMappings(requestParameters: ValidateDomainMappingIdpClaimMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdpClaimMappingValidationResponse>;

}

/**
 * 
 */
export class CustomerDomainManagementApi extends runtime.BaseAPI implements CustomerDomainManagementApiInterface {

    /**
     * Adds a new domain mapping to a customer (requires customers:update permission and customer access)
     * Add domain to customer
     */
    async addDomainToCustomerRaw(requestParameters: AddDomainToCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainMappingResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling addDomainToCustomer().'
            );
        }

        if (requestParameters['addDomainToCustomerRequest'] == null) {
            throw new runtime.RequiredError(
                'addDomainToCustomerRequest',
                'Required parameter "addDomainToCustomerRequest" was null or undefined when calling addDomainToCustomer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/customers/{customerId}/domains`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddDomainToCustomerRequestToJSON(requestParameters['addDomainToCustomerRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainMappingResponseFromJSON(jsonValue));
    }

    /**
     * Adds a new domain mapping to a customer (requires customers:update permission and customer access)
     * Add domain to customer
     */
    async addDomainToCustomer(requestParameters: AddDomainToCustomerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainMappingResponse> {
        const response = await this.addDomainToCustomerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns domains grouped by customerId for customers accessible via the provided tenantIds.
     * Bulk get customer domains
     */
    async bulkGetCustomerDomainsRaw(requestParameters: BulkGetCustomerDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BulkCustomerDomainsGroupedResponse>> {
        if (requestParameters['bulkCustomerDomainsRequest'] == null) {
            throw new runtime.RequiredError(
                'bulkCustomerDomainsRequest',
                'Required parameter "bulkCustomerDomainsRequest" was null or undefined when calling bulkGetCustomerDomains().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/customers/domains/bulk`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkCustomerDomainsRequestToJSON(requestParameters['bulkCustomerDomainsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BulkCustomerDomainsGroupedResponseFromJSON(jsonValue));
    }

    /**
     * Returns domains grouped by customerId for customers accessible via the provided tenantIds.
     * Bulk get customer domains
     */
    async bulkGetCustomerDomains(requestParameters: BulkGetCustomerDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BulkCustomerDomainsGroupedResponse> {
        const response = await this.bulkGetCustomerDomainsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Administrative endpoint to fix mismatched Keycloak aliases in domain mappings (requires customers:update permission and customer access)
     * Fix mismatched Keycloak aliases
     */
    async fixMismatchedAliasesRaw(requestParameters: FixMismatchedAliasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling fixMismatchedAliases().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/domains/fix-aliases`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Administrative endpoint to fix mismatched Keycloak aliases in domain mappings (requires customers:update permission and customer access)
     * Fix mismatched Keycloak aliases
     */
    async fixMismatchedAliases(requestParameters: FixMismatchedAliasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.fixMismatchedAliasesRaw(requestParameters, initOverrides);
    }

    /**
     * Returns whether Azure Enterprise App (multi-tenant) mode is available for domain mappings.  This endpoint allows tenants to check if they can use the system-level Enterprise Application when creating domain mappings, without needing to see the actual Enterprise App configuration.  **Use Case:** When adding a domain mapping via the \"Add Domain Mapping\" dialog, tenants can call this endpoint to determine if they should show: 1. **Enterprise App option** (if available): Only requires tenant ID, uses shared enterprise application 2. **App Registration option**: Requires tenant ID, client ID, and client secret (customer\'s own app registration)  **Response Fields:** - `enabled`: Whether Enterprise App mode is available/enabled - `endpointType`: Multi-tenant endpoint type (\"organizations\" or \"common\") when enabled - `requiresClientCredentials`: Whether clientId/clientSecret are required when NOT using enterprise app  **Frontend Usage:** - Call this endpoint before showing the domain mapping SSO configuration form - If `enabled=true`, show a toggle/choice: \"Use Enterprise App\" or \"Use My Own App Registration\" - If customer chooses \"Use Enterprise App\", only show tenantId field - If customer chooses \"Use My Own App Registration\" or `enabled=false`, show tenantId, clientId, and clientSecret fields - Set `useEnterpriseApp=true` in the request when customer chooses enterprise app option 
     * Get Azure Enterprise App configuration status
     */
    async getAzureEnterpriseAppStatus1Raw(requestParameters: GetAzureEnterpriseAppStatus1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getAzureEnterpriseAppStatus1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/domains/azure-enterprise-app-status`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns whether Azure Enterprise App (multi-tenant) mode is available for domain mappings.  This endpoint allows tenants to check if they can use the system-level Enterprise Application when creating domain mappings, without needing to see the actual Enterprise App configuration.  **Use Case:** When adding a domain mapping via the \"Add Domain Mapping\" dialog, tenants can call this endpoint to determine if they should show: 1. **Enterprise App option** (if available): Only requires tenant ID, uses shared enterprise application 2. **App Registration option**: Requires tenant ID, client ID, and client secret (customer\'s own app registration)  **Response Fields:** - `enabled`: Whether Enterprise App mode is available/enabled - `endpointType`: Multi-tenant endpoint type (\"organizations\" or \"common\") when enabled - `requiresClientCredentials`: Whether clientId/clientSecret are required when NOT using enterprise app  **Frontend Usage:** - Call this endpoint before showing the domain mapping SSO configuration form - If `enabled=true`, show a toggle/choice: \"Use Enterprise App\" or \"Use My Own App Registration\" - If customer chooses \"Use Enterprise App\", only show tenantId field - If customer chooses \"Use My Own App Registration\" or `enabled=false`, show tenantId, clientId, and clientSecret fields - Set `useEnterpriseApp=true` in the request when customer chooses enterprise app option 
     * Get Azure Enterprise App configuration status
     */
    async getAzureEnterpriseAppStatus1(requestParameters: GetAzureEnterpriseAppStatus1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAzureEnterpriseAppStatus1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves or recalculates the Azure AD admin consent URL for a domain mapping tied to an Enterprise App.  This endpoint is useful when: - The Enterprise App was initially created with minimal information (client ID, secret) - The domain mapping was created and tied to the EA - The EA was later updated with additional required fields (scopes, redirect URI, etc.) - The consent URL needs to be recalculated with the updated EA configuration  The endpoint will: 1. Verify the domain mapping exists and is configured for Azure AD with Enterprise App 2. Resolve the Enterprise App configuration (checking tenant hierarchy if needed) 3. Generate the consent URL using current EA configuration (scopes, redirect URI, etc.) 4. Return detailed error information if the consent URL cannot be generated  **Required Conditions:** - Domain mapping must exist - Provider type must be Azure AD - Domain must not be already verified - Domain mapping must be bound to a tenant - Enterprise App must be enabled (useEnterpriseApp=true) - Enterprise App configuration must be valid and contain required fields 
     * Get Azure AD admin consent URL for domain mapping
     */
    async getConsentUrlRaw(requestParameters: GetConsentUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConsentUrlResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getConsentUrl().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling getConsentUrl().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/domains/{domainId}/consent-url`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConsentUrlResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves or recalculates the Azure AD admin consent URL for a domain mapping tied to an Enterprise App.  This endpoint is useful when: - The Enterprise App was initially created with minimal information (client ID, secret) - The domain mapping was created and tied to the EA - The EA was later updated with additional required fields (scopes, redirect URI, etc.) - The consent URL needs to be recalculated with the updated EA configuration  The endpoint will: 1. Verify the domain mapping exists and is configured for Azure AD with Enterprise App 2. Resolve the Enterprise App configuration (checking tenant hierarchy if needed) 3. Generate the consent URL using current EA configuration (scopes, redirect URI, etc.) 4. Return detailed error information if the consent URL cannot be generated  **Required Conditions:** - Domain mapping must exist - Provider type must be Azure AD - Domain must not be already verified - Domain mapping must be bound to a tenant - Enterprise App must be enabled (useEnterpriseApp=true) - Enterprise App configuration must be valid and contain required fields 
     * Get Azure AD admin consent URL for domain mapping
     */
    async getConsentUrl(requestParameters: GetConsentUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConsentUrlResponse> {
        const response = await this.getConsentUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific domain mapping for a customer (requires customers:read permission and customer access)
     * Get customer domain by ID
     */
    async getCustomerDomainRaw(requestParameters: GetCustomerDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainMappingResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCustomerDomain().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling getCustomerDomain().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/domains/{domainId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainMappingResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific domain mapping for a customer (requires customers:read permission and customer access)
     * Get customer domain by ID
     */
    async getCustomerDomain(requestParameters: GetCustomerDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainMappingResponse> {
        const response = await this.getCustomerDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all domains for a customer (requires customers:read permission and customer access)
     * Get customer domains
     */
    async getCustomerDomainsRaw(requestParameters: GetCustomerDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainMappingListResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getCustomerDomains().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/domains`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainMappingListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all domains for a customer (requires customers:read permission and customer access)
     * Get customer domains
     */
    async getCustomerDomains(requestParameters: GetCustomerDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainMappingListResponse> {
        const response = await this.getCustomerDomainsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a domain mapping from a customer (requires customers:update permission and customer access)
     * Remove domain from customer
     */
    async removeDomainFromCustomerRaw(requestParameters: RemoveDomainFromCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling removeDomainFromCustomer().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling removeDomainFromCustomer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/domains/{domainId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a domain mapping from a customer (requires customers:update permission and customer access)
     * Remove domain from customer
     */
    async removeDomainFromCustomer(requestParameters: RemoveDomainFromCustomerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeDomainFromCustomerRaw(requestParameters, initOverrides);
    }

    /**
     * Updates an existing domain mapping for a customer (requires customers:update permission and customer access)
     * Update customer domain
     */
    async updateCustomerDomainRaw(requestParameters: UpdateCustomerDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DomainMappingResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updateCustomerDomain().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling updateCustomerDomain().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateCustomerDomain().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/customers/{customerId}/domains/{domainId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DomainMappingResponseFromJSON(jsonValue));
    }

    /**
     * Updates an existing domain mapping for a customer (requires customers:update permission and customer access)
     * Update customer domain
     */
    async updateCustomerDomain(requestParameters: UpdateCustomerDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DomainMappingResponse> {
        const response = await this.updateCustomerDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validates IdP claim mapping rules scoped to this SSO integration using format heuristics and, when available, provider-specific external lookups. 
     * Validate IdP claim mappings for a domain mapping
     */
    async validateDomainMappingIdpClaimMappingsRaw(requestParameters: ValidateDomainMappingIdpClaimMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdpClaimMappingValidationResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling validateDomainMappingIdpClaimMappings().'
            );
        }

        if (requestParameters['domainId'] == null) {
            throw new runtime.RequiredError(
                'domainId',
                'Required parameter "domainId" was null or undefined when calling validateDomainMappingIdpClaimMappings().'
            );
        }

        if (requestParameters['domainMappingIdpClaimMappingValidateRequest'] == null) {
            throw new runtime.RequiredError(
                'domainMappingIdpClaimMappingValidateRequest',
                'Required parameter "domainMappingIdpClaimMappingValidateRequest" was null or undefined when calling validateDomainMappingIdpClaimMappings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/customers/{customerId}/domains/{domainId}/idp-claim-mappings/validate`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"domainId"}}`, encodeURIComponent(String(requestParameters['domainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DomainMappingIdpClaimMappingValidateRequestToJSON(requestParameters['domainMappingIdpClaimMappingValidateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IdpClaimMappingValidationResponseFromJSON(jsonValue));
    }

    /**
     * Validates IdP claim mapping rules scoped to this SSO integration using format heuristics and, when available, provider-specific external lookups. 
     * Validate IdP claim mappings for a domain mapping
     */
    async validateDomainMappingIdpClaimMappings(requestParameters: ValidateDomainMappingIdpClaimMappingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdpClaimMappingValidationResponse> {
        const response = await this.validateDomainMappingIdpClaimMappingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
